import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`

export const PanelsWrapper = styled.div`
  display: flex;
  gap: ${tokens.spacing.verticalLarge};
  flex: 1;
  min-height: 0;
  margin-top: ${tokens.spacing.verticalLarge};
  overflow-y: auto;

  @media (max-width: ${tokens.breakpoints.tabletSmall}px) {
    flex-direction: column;
    gap: ${tokens.spacing.verticalSmall};
    margin-top: ${tokens.spacing.verticalSmall};
  }
`

export const Panel = styled.div`
  flex: 1;
  border: 1px solid ${tokens.colors.dark2};
  border-radius: ${tokens.radius.medium};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
`

export const PanelHeader = styled.div`
  background: ${tokens.colors.white};
  border-bottom: 1px solid ${tokens.colors.dark2};
  padding: ${tokens.spacing.insetMedium};
  display: flex;
  align-items: center;
  gap: ${tokens.spacing.insetMedium};
  box-shadow: 0px 4px 5px 0px rgba(5, 59, 75, 0.06);
  min-height: 64px;
  flex-shrink: 0;
`

export const PanelTitle = styled.span`
  font-weight: ${tokens.fontWeights.bold};
  color: ${tokens.colors.dark5};
  font-size: ${tokens.fontSize.medium};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const BackButton = styled.button`
  background: ${tokens.colors.white};
  border: 1px solid ${tokens.colors.dark3};
  border-radius: ${tokens.radius.medium};
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
`

export const SearchWrapper = styled.div`
  padding: ${tokens.spacing.insetSmall};
  flex-shrink: 0;
`

export const SearchContainer = styled.div`
  background: ${tokens.colors.dark1};
  border-radius: ${tokens.radius.medium};
  display: flex;
  align-items: center;
  padding: 0 12px;
  height: 40px;
  gap: 8px;
`

export const SearchInput = styled.input`
  background: transparent;
  border: none;
  outline: none;
  color: ${tokens.colors.dark5};
  font-size: ${tokens.fontSize.medium};
  width: 100%;
  font-family: inherit;

  &::placeholder {
    color: ${tokens.colors.dark5};
  }
`

export const ListWrapper = styled.div`
  flex: 1;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${tokens.colors.dark2};
    border-radius: 3px;
  }
`

export const ListRow = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  border-bottom: 1px solid ${tokens.colors.dark1};
  background: ${tokens.colors.white};
  cursor: pointer;
  gap: 8px;

  &:hover {
    background: ${tokens.colors.dark1};
  }
`

export const ListRowText = styled.span`
  flex: 1;
  font-size: ${tokens.fontSize.medium};
  color: ${tokens.colors.dark5};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const DegreeTag = styled.span`
  border: 1px solid ${tokens.colors.dark4};
  border-radius: 500px;
  padding: 4px 8px;
  font-size: ${tokens.fontSize.small};
  font-weight: ${tokens.fontWeights.bold};
  color: ${tokens.colors.dark5};
  white-space: nowrap;
  flex-shrink: 0;
`

export const SelectedPanel = styled.div`
  flex: 1;
  border: 1px solid ${tokens.colors.dark2};
  border-radius: ${tokens.radius.medium};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: ${tokens.spacing.insetMedium};
`

export const SelectedPanelTitle = styled.div`
  font-weight: ${tokens.fontWeights.bold};
  color: ${tokens.colors.dark5};
  font-size: ${tokens.fontSize.medium};
  margin-bottom: ${tokens.spacing.verticalLarge};
  flex-shrink: 0;
`

export const SelectedListWrapper = styled.div`
  flex: 1;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${tokens.colors.dark2};
    border-radius: 3px;
  }
`

export const SelectedRow = styled.div`
  min-height: 52px;
  display: flex;
  align-items: center;
  padding: 14px 0;
  border-bottom: 1px solid ${tokens.colors.dark1};
  gap: 8px;
`

export const SelectedRowName = styled.span`
  flex: 1;
  font-weight: ${tokens.fontWeights.bold};
  font-size: ${tokens.fontSize.medium};
  color: ${tokens.colors.dark5};
`

export const RemoveButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: ${tokens.radius.small};

  &:hover {
    background: ${tokens.colors.dark1};
  }
`

export const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 1;
  padding: ${tokens.spacing.insetLarge};
`

export const EmptyStateTitle = styled.p`
  font-weight: ${tokens.fontWeights.bold};
  font-size: ${tokens.fontSize.large};
  color: ${tokens.colors.dark6};
  text-align: center;
`

export const EmptyStateSubtitle = styled.p`
  font-size: ${tokens.fontSize.small};
  color: ${tokens.colors.dark5};
  text-align: center;
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${tokens.spacing.verticalSmall};
  padding-top: ${tokens.spacing.verticalXlarge};
  flex-shrink: 0;
`
